
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index8FLWZU5AuylwS_45551uiUznaUpOsKkgJtU3IpjDqwbt0Meta } from "/app/apps/web/src/pages/index.vue?macro=true";
import { default as loadYBhlw4Od62ajyPzuqUp7jwpI_45WrjA0mkYQ0JHuZZKK4Meta } from "/app/apps/web/src/pages/app/load.vue?macro=true";
import { default as loginOlhomPkKwgWK2BTGA_45Cl8U5lt6UdmY1Bfxnhuw2il4IMeta } from "/app/apps/web/src/pages/auth/login.vue?macro=true";
import { default as logout1h4tQBW3Q9sxHmFhQLzkC_45BOdxkdTqKaSJDnK8yG_AEMeta } from "/app/apps/web/src/pages/auth/logout.vue?macro=true";
import { default as _91id_939zKFd49pRR7N9cNFVPbiMf2s9vxDkWRYpnT4G0wsL4oMeta } from "/app/apps/web/src/pages/project/[id].vue?macro=true";
import { default as profileMTlVMSqBjpA_45UXZKrgk3f6NJT4yAV7fPAIust8rE7wkMeta } from "/app/apps/web/src/pages/user/profile.vue?macro=true";
import { default as indexY71QFc5nkVzkzIh44QoWkhdYGDHvahwmMzdZkv9PWgkMeta } from "/app/apps/web/src/pages/subscription/index.vue?macro=true";
import { default as silent_45refreshdJh0wwQAyBhT9zUgLv544oWrXbO4KgKsiOF4q39yzxAMeta } from "/app/apps/web/src/pages/auth/silent-refresh.vue?macro=true";
import { default as _91_46_46_46slug_934bCyPt7Y4e5TLuYrpbSfp82IWOI2veUSzV2gqptIKa8Meta } from "/app/apps/web/src/pages/newsletter/add/[...slug].vue?macro=true";
import { default as _91_46_46_46slug_939Cv5zKVQn1fkR_45weIFO2CY4zvXG9uhhheSzFvNZhNfkMeta } from "/app/apps/web/src/pages/newsletter/remove/[...slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/apps/web/src/pages/index.vue")
  },
  {
    name: "app-load",
    path: "/app/load",
    meta: loadYBhlw4Od62ajyPzuqUp7jwpI_45WrjA0mkYQ0JHuZZKK4Meta || {},
    component: () => import("/app/apps/web/src/pages/app/load.vue")
  },
  {
    name: "auth-login",
    path: "/auth/login",
    component: () => import("/app/apps/web/src/pages/auth/login.vue")
  },
  {
    name: "auth-logout",
    path: "/auth/logout",
    component: () => import("/app/apps/web/src/pages/auth/logout.vue")
  },
  {
    name: "project-id",
    path: "/project/:id()",
    meta: { ...(_91id_939zKFd49pRR7N9cNFVPbiMf2s9vxDkWRYpnT4G0wsL4oMeta || {}), ...{"middleware":["auth-project"]} },
    component: () => import("/app/apps/web/src/pages/project/[id].vue")
  },
  {
    name: "user-profile",
    path: "/user/profile",
    meta: profileMTlVMSqBjpA_45UXZKrgk3f6NJT4yAV7fPAIust8rE7wkMeta || {},
    component: () => import("/app/apps/web/src/pages/user/profile.vue")
  },
  {
    name: "subscription",
    path: "/subscription",
    component: () => import("/app/apps/web/src/pages/subscription/index.vue")
  },
  {
    name: "auth-silent-refresh",
    path: "/auth/silent-refresh",
    component: () => import("/app/apps/web/src/pages/auth/silent-refresh.vue")
  },
  {
    name: "newsletter-add-slug",
    path: "/newsletter/add/:slug(.*)*",
    component: () => import("/app/apps/web/src/pages/newsletter/add/[...slug].vue")
  },
  {
    name: "newsletter-remove-slug",
    path: "/newsletter/remove/:slug(.*)*",
    component: () => import("/app/apps/web/src/pages/newsletter/remove/[...slug].vue")
  }
]